var render, staticRenderFns
import script from "./LocalBackground.vue?vue&type=script&lang=tsx"
export * from "./LocalBackground.vue?vue&type=script&lang=tsx"
import style0 from "./LocalBackground.vue?vue&type=style&index=0&id=5b71e4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b71e4ba",
  null
  
)

export default component.exports